import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl } from "../Utils/Utils";
import { useNavigate } from "react-router-dom";

function VerifyEmail() {
    const [status, setStatus] = useState("loading");
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        if (!token) {
            setStatus("invalid");
            return;
        }
        axios.get(`${getBaseUrl()}/user/verify-email?token=${token}`)
            .then(() => setStatus("success"))
            .catch(() => setStatus("error"));
    }, []);

    return (
        <section className="section-padding mt-5">
            <div className="container text-center" style={{ maxWidth: 480, margin: "0 auto", padding: "60px 20px" }}>
                {status === "loading" && (
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Verifying...</span>
                    </div>
                )}
                {status === "success" && (
                    <>
                        <i className="ti-check-box" style={{ fontSize: "3rem", color: "#28a745" }}></i>
                        <h4 className="mt-3">Email Verified!</h4>
                        <p className="text-muted">Your email has been verified successfully. You can now log in.</p>
                        <button className="btn btn-primary btn-rounded mt-2" onClick={() => navigate("/")}>
                            Go to Home
                        </button>
                    </>
                )}
                {(status === "error" || status === "invalid") && (
                    <>
                        <i className="ti-close" style={{ fontSize: "3rem", color: "#dc3545" }}></i>
                        <h4 className="mt-3">Verification Failed</h4>
                        <p className="text-muted">The verification link is invalid or has already been used.</p>
                        <button className="btn btn-secondary btn-rounded mt-2" onClick={() => navigate("/")}>
                            Go to Home
                        </button>
                    </>
                )}
            </div>
        </section>
    );
}

export default VerifyEmail;
